
module.config(function($stateProvider) {

    $stateProvider.state('settings.grantNames', {
        url: '/grant-names',
        templateUrl: 'settings/grantNames',
        permission: 'administerSystem',
        resolve: {
            grantNameUrl: function(ApiUrl) {
                return ApiUrl.partial('grant_name');
            },
            grantNames: function($http, grantNameUrl) {
                return $http.get(grantNameUrl()).then(function(response) {
                    return response.data.items;
                });
            },
        },
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['$scope', '$q', '$http', 'grantNames', 'grantNameUrl'],
            data: {grantNames: 'grantNames'},
            methods: {
                edit: function(grant, isDol) {
                    grant.editing = true;
                    grant.formData = {
                        is_tag: grant.is_tag,
                        enabled: !!grant.enabled,
                    };

                    if (!isDol) {
                        grant.formData.sub_name = grant.sub_name;
                        grant.formData.source = grant.source;
                        grant.formData.direct = grant.direct;
                        grant.formData.name = grant.name;
                        grant.formData.sub_name = grant.sub_name;
                    }
                },

                cancel: function(grant) {
                    delete grant.editing;
                    delete grant.formData;
                },

                delete: function(grant) {
                    console.log(grant);
                    if (grant.count !== 0) return this.$q.reject();
                    return this.$http.delete(this.grantNameUrl(grant.id));
                },

                remove: function(grant) {
                    var index = this.grantNames.indexOf(grant);
                    if(index >= 0) {
                        this.grantNames.splice(index, 1);
                    }
                },

                save: function(form, grant) {
                    var self = this;
                    if (form.$invalid) return this.$q.reject();

                    if (grant.id) {
                        return this.$http.patch(this.grantNameUrl(grant.id), grant.formData)
                            .then(function(response) {
                                angular.extend(grant, response.data.item);
                                return grant;
                            })
                    } else {
                        return this.$http.post(this.grantNameUrl(), grant)
                            .then(function(response) {
                                self.grantNames.unshift(response.data.item);
                            });
                    }
                }
            }
        }),
    });

});
